"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyProfileGallery = void 0;
const CompanyProfileGallery_1 = require("./CompanyProfileGallery");
Object.defineProperty(exports, "CompanyProfileGallery", { enumerable: true, get: function () { return CompanyProfileGallery_1.CompanyProfileGallery; } });
